<template>
  <div class="ddpc-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="车间" prop="factory">
              <el-select v-model="searchForm.factory" style="width: 120px" filterable clearable>
                <el-option v-for="item in factoryList" :label="item.simple_name" :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
<!--            <el-form-item>-->
<!--              <el-button icon="el-icon-printer" type="primary" @click="openDirect">打印生产指令单</el-button>-->
<!--            </el-form-item>-->
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button-group>
                <el-button :type="mark===12?'primary':''" size="small" @click="changeMark(12)">未排产</el-button>
                <el-button :type="mark===13?'primary':''" size="small" @click="changeMark(13)">已排产</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="150"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="计划交期"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.pmcplanned}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单金额"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#409EFF">{{scope.row.facamount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="色板来源"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
<!--                      <span v-if="scope.row.color_source===0">厂部标准色板</span>-->
<!--                      <span style="color:#F56C6C" v-if="scope.row.color_source===1">客户提供色板</span>-->
<!--                      <span style="color:#F56C6C" v-if="scope.row.color_source===2">厂部定制色板</span>-->
                      <span>{{scope.row.color_source}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="分派工厂"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">{{scope.row.factory_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产接单时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.factory_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right">
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" type="warning" v-if="scope.row.status===12 || scope.row.status===11">待排产</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.status===13">生产中</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    fixed="right"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-date" v-if="scope.row.status===12 || scope.row.status===11" @click.stop="schedule(scope.row)">订单排产</el-button>
                      <el-button size="mini" icon="el-icon-edit" v-if="scope.row.status===13" @click.stop="schedule(scope.row)">编辑排产</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="订单排产"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules" v-loading="formLoading" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <!-- <div v-for="(item, index) in editForm.process" :key="item.key">
          <el-form-item :label="item.process_name" :prop="'process.' + index +'.process_name'" :rules="{required: true, message: '请选择日期', trigger: 'change'}">
            <div style="position: absolute">
              <i class="el-icon-remove-outline" style="color:#99a9bf" v-if="item.isComplete===0&&editForm.mark===12"></i>
              <i class="el-icon-time" style="color:#E6A23C" v-if="item.isComplete===0&&editForm.mark===13"></i>
              <i class="el-icon-success" style="color:#67C23A" v-if="item.isComplete===1"></i>
            </div>
            <el-date-picker
              disabled
              v-model="item.pmctime"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <el-date-picker
              @change="changePlanned"
              v-model="item.time"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择生产回复日期">
            </el-date-picker>
          </el-form-item>
        </div> -->
        <el-form-item label="计划交期" prop="planned">
          <el-date-picker
            disabled
            v-model="editForm.PMCplanned"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <el-date-picker
            :disabled="false"
            v-model="editForm.planned"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择生产回复日期">
          </el-date-picker>
        </el-form-item>
<!--        <el-form-item label="色板信息" prop="swatch">-->
<!--          <el-input v-model="editForm.swatch" type="textarea" maxlength="100" show-word-limit></el-input>-->
<!--        </el-form-item>-->
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="打印生产指令单"
      :visible.sync="directVisible"
      width="75%"
      :destroy-on-close="true"
      :lock-scroll="true"
      top="8vh"
      :append-to-body="true">
      <el-container>
        <el-header>
          <el-form ref="directForm" :inline="true" size="small" :model="directForm" :rules="directRules">
            <el-form-item label="车间" prop="factory">
              <el-select v-model="directForm.factory" style="width: 120px" filterable clearable>
                <el-option v-for="item in factoryList" :key="item.factory_id" :label="item.simple_name" :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model="directForm.type" style="width: 120px" filterable clearable>
                <el-option label="正单" :value="0" />
                <el-option label="补单" :value="5" />
                <el-option label="客改单" :value="1" />
                <el-option label="增补单" :value="2" />
                <el-option label="色板单" :value="3" />
                <el-option label="售后单" :value="4" />
              </el-select>
            </el-form-item>
            <el-form-item label="接单时间">
              <el-date-picker
                v-model="directForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                type="daterange">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="搜索关键字" prop="search">
              <el-input v-model="directForm.search" placeholder="订单搜索" @keyup.enter.native="getOrders('directForm')"/>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getOrders('directForm')">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-header>
        <el-main style="padding-top:0">
          <table cellspacing="0" width="100%;" style="margin-bottom: 20px;">
            <thead>
              <tr>
                <th style="border-right: none;" align="left">编号：<el-input v-model="directForm.code" size="small" placeholder="请输入编号" style="width: 250px;"/></th>
                <th style="border-right: none;border-left: none;">标题：<el-input v-model="directForm.title" size="small" placeholder="请输入标题" style="width: 250px;"/></th>
                <th style="border-left: none;" align="right">计划单号：<el-input v-model="directForm.planOrderNum" size="small" placeholder="请输入计划单号" style="width: 250px;"/></th>
              </tr>
            </thead>
          </table>
          <pl-table
            ref="directTable"
            v-loading="directLoading"
            :datas="directOrderList"
            :data="directOrderList"
            tooltip-effect="dark"
            style="width: 100%;min-height: 400px;"
            :pagination-show="false"
            size="small"
            use-virtual
            bigDataCheckbox
            row-key="id"
            @selection-change="directSelectionChange">
            <pl-table-column
              type="selection"
              align="center"
              fixed
              width="50">
            </pl-table-column>
            <pl-table-column
              label="生产单号"
              width="120"
              align="center"
              fixed
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
              </template>
            </pl-table-column>
            <pl-table-column
              label="经销商"
              width="120"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.all_name}}</span>
              </template>
            </pl-table-column>
            <pl-table-column
              label="详细地址"
              min-width="160"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.address}}</span>
              </template>
            </pl-table-column>
            <pl-table-column
              label="订单金额"
              width="140"
              align="center"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="color:#409EFF">{{scope.row.facamount}}</span>
              </template>
            </pl-table-column>
            <pl-table-column
              label="色板来源"
              width="140"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.color_source}}</span>
<!--                <span v-if="scope.row.color_source===0">厂部标准色板</span>-->
<!--                <span style="color:#F56C6C" v-if="scope.row.color_source===1">客户提供色板</span>-->
<!--                <span style="color:#F56C6C" v-if="scope.row.color_source===2">厂部定制色板</span>-->
              </template>
            </pl-table-column>
            <pl-table-column
              label="分派工厂"
              width="120"
              align="center"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span style="color:#99a9bf">{{scope.row.factory_name}}</span>
              </template>
            </pl-table-column>
            <pl-table-column
              label="生产接单时间"
              width="170"
              show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{scope.row.factory_time}}</span>
              </template>
            </pl-table-column>
          </pl-table>
        </el-main>
        <el-footer style="text-align: right;height:40px;">
          <el-button icon="el-icon-printer" size="small" :loading="directBtnLoading" type="primary" @click="printProduceDirect">打印生产指令单</el-button>
          <el-button size="small" @click="directVisible = false">取 消</el-button>
        </el-footer>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getOrderProductList,
  orderSchedule,
  getProcessList,
  getFactoryList,
  getDirectOrderList,
  printProduceDirect,
  exportOrderPlanProductList
} from '@/api/erp'
import { dateFormat } from '@/utils/index'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'ddpc',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      mark: 12,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editloading: false,
      formLoading: false,
      editForm: {
        orderid: '',
        ordername: '',
        // swatch: '',
        process: [],
        mark: null,
        PMCplanned: null,
        planned: null
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        planned: [{ required: true, message: '请选择生产回复时间', trigger: 'blur' }],
        // swatch: [{ required: true, message: '请输入色板信息', trigger: 'blur' }]
      },
      // processRules: {
      //   process_name: [{ required: true, message: '请输入工序天数', trigger: 'blur' }]
      // },
      searchForm: {
        search: '',
        factory: null,
        type: null
      },
      directForm: {
        title: '耐思迪生产指令单',
        code: 'NSD-OEM-BG-001',
        planOrderNum: dateFormat('YYYY-mm-dd', new Date()),
        factory: '',
        search: '',
        directSelect: [],
        type: '',
        time: []
      },
      directRules: {
        factory: [{ required: true, message: '请选择车间', trigger: 'change' }]
      },
      factoryList: [],
      directOrderList: [],
      directLoading: false,
      directVisible: false,
      directBtnLoading: false
    }
  },
  created() {
    this.getData()
    this.getFactoryList()
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          type: this.searchForm.type,
          groupid: this.user.dGroupid,
          mark: this.mark,
          userid: this.user.dUserid,
          role: this.user.role,
          tableName: '订单排产列表'
        }
        exportOrderPlanProductList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    // changePlanned() {
    //   let temp
    //   for (let i = 0; i < this.editForm.process.length; i++) {
    //     if (this.editForm.process[i].time !== null && this.editForm.process[i].time !== '' && this.editForm.process[i].time !== undefined) {
    //       temp = this.editForm.process[i].time
    //       break
    //     }
    //   }
    //   for (let i = 0; i < this.editForm.process.length; i++) {
    //     const olded = new Date(Date.parse(temp))
    //     const ed = new Date(Date.parse(this.editForm.process[i].time))
    //     if (ed > olded) {
    //       temp = this.editForm.process[i].time
    //     }
    //   }
    //   this.editForm.planned = temp
    // },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    changeMark(n) {
      if (n === this.mark) {
        return false
      } else {
        this.mark = n
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        type: this.searchForm.type,
        factory: this.searchForm.factory,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        mark: this.mark,
        userid: this.user.dUserid,
        role: this.user.role,
        process: 12 // 订单排产
      }
      getOrderProductList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({
        path: '/work/order/' + row.order_id.substring(0, 36),
        query: {
          data: row.factory_id
        }
      })
    },
    schedule(row) {
      this.editForm.orderid = row.order_id
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.swatch = row.swatch
      this.editForm.mark = row.status
      this.editForm.PMCplanned = row.pmcplanned
      this.editForm.planned = row.planned
      this.editVisible = true
      // this.formLoading = true
      // console.log('orderid: ' + this.editForm.orderid)
      // getProcessList({ orderid: this.editForm.orderid }).then(response => {
      //   this.editForm.process = response.data
      //   this.formLoading = false
      //   this.changePlanned()
      // }).catch(() => {
      //   this.editForm.process = []
      //   this.formLoading = false
      // })
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // for (let p of this.editForm.process) {
          //   if (p.time === '' || p.time === null || p.time === undefined) {
          //     this.$message.error('必填信息不能为空！！！')
          //     return
          //   }
          // }
          this.SubScheduleOrder()
        } else {
          return false
        }
      })
    },
    SubScheduleOrder() {
      if (!this.editloading) {
        console.log('orderid: ' + this.editForm.orderid)
        this.editloading = true
        let jsonStr = ''
        // for (let p of this.editForm.process) {
        //   jsonStr += '"' + p.process_id + '":' + '"' + p.time + '"' + ','
        // }
        // if (jsonStr.length > 0) {
        //   jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
        // }
        // let temp = this.editForm.process[0].time
        // for (let i = 1; i < this.editForm.process.length; i++) {
        //   const olded = new Date(Date.parse(temp))
        //   const ed = new Date(Date.parse(this.editForm.process[i].time))
        //   if (ed > olded) {
        //     temp = this.editForm.process[i].time
        //   }
        // }
        const data = {
          userid: this.user.dUserid,
          orderid: this.editForm.orderid,
          // colorinfo: this.editForm.swatch,
          planned: this.editForm.planned,
          jsonStr: jsonStr
        }
        orderSchedule(data).then(response => {
          this.$message({
            message: '订单排产成功',
            type: 'success'
          })
          this.editloading = false
          this.editVisible = false
          this.getData()
        }).catch(() => {
          this.editloading = false
        })
      } else {
        return false
      }
    },
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    getOrders(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let startTime = ''
          let endTime = ''
          if (this.directForm.time !== null && this.directForm.time.length === 2) {
            startTime = this.directForm.time[0]
            endTime = this.directForm.time[1]
          }
          const data = {
            content: this.directForm.search,
            groupid: this.user.dGroupid,
            mark: 13,
            userid: this.user.dUserid,
            role: this.user.role,
            factory: this.directForm.factory,
            type: this.directForm.type,
            startTime: startTime,
            endTime: endTime
          }
          this.directLoading = true
          getDirectOrderList(data).then(response => {
            this.directOrderList = response.data
            this.directLoading = false
          })
        }
      })
    },
    directSelectionChange(val) {
      this.directForm.directSelect = val
    },
    openDirect() {
      this.directForm.title = '耐思迪生产指令单'
      this.directForm.code = 'NSD-OEM-BG-001'
      this.directForm.planOrderNum = dateFormat('YYYY-mm-dd', new Date())
      this.directForm.factory = ''
      this.directForm.search = ''
      this.directForm.type = null
      this.directOrderList = []
      this.directForm.directSelect = []
      this.directVisible = true
    },
    printProduceDirect() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        /* this.directBtnLoading = true*/
        if (this.directForm.factory === null || this.directForm.factory === '') {
          this.$message({
            message: '请选择车间',
            type: 'danger'
          })
          return false
        }
        if (this.directForm.title === null || this.directForm.title === '') {
          this.$message({
            message: '请填写标题',
            type: 'danger'
          })
          return false
        }
        if (this.directForm.code === null || this.directForm.code === '') {
          this.$message({
            message: '请填写编号',
            type: 'danger'
          })
          return false
        }
        if (this.directForm.planOrderNum === null || this.directForm.planOrderNum === '') {
          this.$message({
            message: '请填写计划单号',
            type: 'danger'
          })
          return false
        }
        if (this.directForm.directSelect === null || this.directForm.directSelect.length === 0) {
          this.$message({
            message: '至少选择一个订单',
            type: 'danger'
          })
          return false
        }
        const orderids = []
        for (const item of this.directForm.directSelect) {
          orderids.push(item.order_id)
        }
        const data = {
          factory: this.directForm.factory,
          title: this.directForm.title,
          code: this.directForm.code,
          planNumber: this.directForm.planOrderNum,
          orderids: orderids.join(',')
        }
        this.directBtnLoading = true
        printProduceDirect(data).then(response => {
          this.directBtnLoading = false
          LODOP.PRINT_INIT('生产指令单打印')
          LODOP.SET_PRINT_PAGESIZE(2, 0, 0, 'A4')
          LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
          LODOP.ADD_PRINT_TABLE(30, 10, '100%', '100%', response.data)
          LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
          LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
          LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
          LODOP.NewPageA()
          LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
          LODOP.PREVIEW()
        }).catch(() => {
          this.directBtnLoading = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ddpc-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
